var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"successful"},[_c('div',[_c('div',{staticClass:"successful_icon"}),_c('div',{staticClass:"successful_content"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }